import claimContractAbi from '../abis/claim-abi.json';
import stakingContractAbi from '../abis/staking-abi.json';
import tokenContractAbi from '../abis/token-abi.json';

export const claimAbi = claimContractAbi;
export const stakingAbi = stakingContractAbi;
export const tokenAbi = tokenContractAbi;

// type `0x${string}`

// TESTNET:
/*
export const addresses: Record<'claim' | 'token' | 'staking', `0x${string}`> = {
  claim: '0x2C8A7E9A3b10E38623A192DF667E3D2a35607B45',
  token: '0x6C8678826a06CD6cE879b181830CbAF2b9989360',
  staking: '0xfD3B51277Bf5d9a0AF0Ee903b078d26e4d379053',
};
*/

export function shortAddress(address: `0x${string}` | string) {
  return address.slice(0, 6) + '...' + address.slice(-4);
}

export const requiredChainIds = [1];

export const addresses: Record<'claim' | 'token' | 'staking', `0x${string}`> = {
  claim: '0xBeAfD8600ee870Bb3D5BbE5d248DBBE3FA2B82f0',
  token: '0xef7f7820a001aabAc5E0979b175C9ff8Af3Dd4ec',
  staking: '0x56d3142a1542942EE463D47b08B6AbC0853fEa99',
};
